import { useState } from 'react';

import { Text } from '../../Form/Inputs/Text.js';
import { Password } from '../../Form/Inputs/Password.js';
import { Email } from '../../Form/Inputs/Email.js';
import { Phone } from '../../Form/Inputs/Phone.js';
import { Date } from '../../Form/Inputs/Date.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const Administrator = (props) => {
    const { el } = props;
    const [email, setEmail] = useState(el ? el.email : '');
    const [password, setPassword] = useState(el ? el.password : '');
    const [phone, setPhone] = useState(el ? el.mobile : '');
    return (
        <>
            <Text name="firstname" value={el ? el.firstname : ''} />
            <Text name="lastname" value={el ? el.lastname : ''} />
            <Phone name="mobile" phone={phone} setPhone={setPhone} />
            <Email email={email} setEmail={setEmail} />
            <Password password={password} setPassword={setPassword} />
            <Date name="date_start" value={el ? el.date_start : ''} />
            <Date name="date_end" value={el ? el.date_end : ''} />
            <Date name="date_current" value={el ? el.date_current : ''}/>
            <Text name="address" value={el ? el.address : ''} />
            <Text name="zipcode" value={el ? el.zipcode : ''} />
            <Text name="city" value={el ? el.city : ''} />
            <Text name="country" value={el ? el.country : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}